import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme:any) => {
  const mutedText = theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.grey[700];
  const hairline = theme.palette.border.line;

  return {
    mapTabContainer: {
      maxHeight: "85vh",
      width: "100%",
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        maxHeight: 'none',
      },
    },
    mapViewContainer: {
      display: "flex",
      flexWrap: "nowrap",
      width: "100%",
      height: "100%",
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        height: 'auto',
      },
    },
    mapContainer: {
      width: "60%",
      height: "85vh",
      minHeight: "85vh",
      backgroundColor: "#f4f4f4",
      padding: "0.5rem",
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '38vh',
        minHeight: theme.spacing(30),
        boxSizing: 'border-box',
        minWidth: 0,
        [theme.breakpoints.down('md')]: {
          width: '100%',
          overflowY: 'visible',
          padding: theme.spacing(2),
        },
      },
    },
    controls: {
      backgroundColor: theme.palette.background.paper,
      flex: 1,
      padding: "1.5rem",
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      overflowY: "scroll",
      boxSizing: 'border-box',
      minWidth: 0,
      [theme.breakpoints.down('md')]: {
        width: '100%',
        overflowY: 'visible',
        padding: theme.spacing(2),
      },
    },
    title: {
      fontSize: "1.3rem",
      color: theme.palette.text.primary,
      fontWeight: 500
    },
    subTitleContainer: {
      marginTop: "0.5rem", display: "flex", justifyContent: "space-between", alignItems: "center"
    },
    subTitle: {
      fontSize: "1rem", color: mutedText, fontWeight: 500
    },
    hideFiltersOnMobile: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    relatedOrdersTitle: {
      fontSize: "1.2rem", color: mutedText, fontWeight: 500
    },
    relatedOrdersTotalsBadge: {
      backgroundColor: alpha(theme.palette.secondary.main, 0.12),
      color: theme.palette.secondary.main,
      fontSize: "0.8rem",
      fontWeight: "bold",
      padding: "5px 10px",
      borderRadius: "50px"
    },
    relatedOrdersListContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      marginTop: "5px",
      overflowX: "hidden",
      overflowY: "auto",
      minHeight: "400px",
      minWidth: 0,
      [theme.breakpoints.down('md')]: {
        minHeight: 0,
        maxHeight: '45vh',
        overflowY: 'auto',
      },
    },
    relatedOrdersitem: {
      border: `1px solid ${theme.palette.border.line}`,
      borderRadius: "7px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0px 3px 8px 0px rgba(29, 29, 29, 0.1)",
      minWidth: 0,
      width: '100%',
      boxSizing: 'border-box',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        padding: theme.spacing(1.5),
        gap: theme.spacing(1),
      },
    },
    relatedOrdersTitleContainer: {
      display: "flex", justifyContent: "space-between", marginTop: "20px"
    },
    relatedOrdersActions: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    mobileClearButton: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'block',
        '& button': {
          minWidth: 0,
          padding: theme.spacing(0.5),
        },
      },
    },
    relatedOrdersListItemContainer: {
      width: "30%",
      minWidth: 0,
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        width: '100%',
      },
    },
    relatedOrdersItemText: {
      fontSize: "0.9rem",
      color: theme.palette.text.primary,
      fontWeight: 500,
      width: "70%",
      height: "100%",
      padding: "10px",
      borderRight: `1px solid ${theme.palette.border.line}`,
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      overflowWrap: 'anywhere',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: 'auto',
        padding: 0,
        borderRight: 'none',
        borderBottom: 'none',
      },
    },
    relatedOrdersItemOrderNumberDivided: {
      borderBottom: `1px solid ${hairline}`,
    },
    relatedOrdersItemOrderNumber: {
      color: theme.palette.text.primary,
      fontWeight: 500,
      padding: "10px",
      fontSize: "0.8rem",
      cursor: "pointer",
      minWidth: 0,
      overflowWrap: 'anywhere',
      "&:hover": {
        textDecoration: "underline"
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0.75, 1),
        border: `1px solid ${theme.palette.border.line}`,
        borderRadius: theme.spacing(0.5),
      },
    },
    searchIcon: { color: theme.palette.text.shadow, fontSize: '0.875rem' },
    searchBox: {
      '& .MuiFilledInput-root': {
        textTransform: 'none',
        fontSize: '0.875rem',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        border: `1.2px solid ${theme.palette.border.line}`,
        padding: theme.spacing(1.2),
      },
      '& .MuiInputBase-inputHiddenLabel': { padding: 0 },
      '& ::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1,
      },
      '& .MuiFilledInput-underline:before': {
        borderBottom: `1.2px solid ${theme.palette.border.line} !important`,
      }
    },
  };
});